import { useEffect, useMemo, useRef, useState } from 'react'
import { Button, Card, Col, Form, Row } from 'react-bootstrap'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { Controller, useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import AlertSuccess from '../../../../alert/AlertSuccess'
import Error_false from '../../../../components/error/error-false'
import BtnBack2 from '../../../../components/btn-back2'
import Autocomplete from '../../../../components/custom/autocomplete'
import NavTitle from '../../../../components/nav-title'
import CardCustom from '../../../../components/custom/card-custom'
import LabelCustom from '../../../../components/custom/LabelCustom'
import { HiOutlinePlus } from 'react-icons/hi'
import TitleCustom from '../../../../components/custom/TitleCustom'
import { ReactComponent as IconLeave } from '../../../../images/iconLeave.svg'
import LabelHeaderCustom from '../../../../components/custom/LabelHeaderCustom'
import { Checkbox } from 'antd'
import { BsX } from 'react-icons/bs'
import {
  delAssignLeveTypeV2API,
  delLeveTypeV2API,
  getDetailLeveTypeV2API,
  postLeveTypeV2API,
  putLeveTypeV2API
} from '../../../../services/setting/leave'
import { DatePickerGuide } from '../../../../components/datepickerCustom'
import { fnDateEn } from '../../../../helper/fnDateEn'
import UseEmpsTypes from '../../../../hooks/use-emps-types'
// import UseSexs from '../../../../hooks/use-emps-sexs'
import { FaRegPenToSquare } from 'react-icons/fa6'
import SwitchStatus from '../../../../components/Switchstatus'
import UseMinimum from '../../../../hooks/use-minimum'
import UseLeaveDuration from '../../../../hooks/use-duration'
import { ReactComponent as IconWarning } from '../../../../images/warning2.svg'
import ModalAlert from '../../../../components/modal-alert'
import { useSelector } from 'react-redux'
import {
  PAGE_SETTING_LEAVE_MAS,
  PAGE_SETTING_LEAVE_ASSIGN
} from '../../../../router/routes'
import { useToggleMenuStore } from '../../../../store/layout'
import TagOrgList from '../../../../components/custom/TagOrgListCustom'
import formatString from '../../../../helper/format-string'
import UseSexsLeave from '../../../../hooks/use-emps-sexs-leave'
import UseLeaveType from '../../../../hooks/use-leave-user-type'

export default function AddSettingLeavePege() {
  const {
    control,
    setValue,
    handleSubmit,
    watch,
    reset,
    formState: { errors, isDirty }
  } = useForm({
    defaultValues: {
      isActive: true
    },
    mode: 'onChange' // ⭐ สำคัญ
  })
  const { t } = useTranslation()
  const roleId = useSelector((state) => state.roleReducer.role)
  const EMP_TYPE = {
    ALL: 0,
    PERMANENT: 1,
    CONTRACT: 2
  }
  const empsTypesFromAPI = UseEmpsTypes([EMP_TYPE.PERMANENT, EMP_TYPE.CONTRACT])
  const empsTypes = useMemo(
    () => [{ value: EMP_TYPE.ALL, label: t('hrms_setting_leave_form_employee_all') }, ...empsTypesFromAPI],
    [empsTypesFromAPI, EMP_TYPE.ALL]
  )
  const [searchParams] = useSearchParams()
  const idParams = searchParams.get('id')
  const leaveType = UseLeaveType(
    idParams ? { excludeLeaveTypeId: idParams } : {}
  )
  const dataOptionMinimum = UseMinimum()
  const dataOptionDuration = UseLeaveDuration()
  const dataSexs = UseSexsLeave()
  const laterDay = watch('later_day')
  const advanceDay = watch('advance_day')
  const attachmentValue = watch('attachment')
  const relateTypeValue = watch('relateType')
  const totalDay = watch('totalDay')
  const getStrictOption = (value) => ({
    value,
    label:
      value === 'later'
        ? t('hrms_setting_leave_form_title_later')
        : t('hrms_setting_leave_form_title_advance')
  })

  const idPage = searchParams.get('page')
  const id = parseInt(idParams, 10)
  const [leaveTypeId, setLeaveTypeId] = useState(id)
  const [details, setDetails] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [isRead, setIsRead] = useState(true)
  // const [isRead, setIsRead] = useState(true)
  const hasId = Boolean(leaveTypeId)
  const [selectedUser, setSelectedUser] = useState(null)
  const navigate = useNavigate()
  const [effectiveStartDate, setEffectiveStartDate] = useState(null)
  const [effectiveEndDate, setEffectiveEndDate] = useState(null)
  const [attachment, setAttachment] = useState(null)
  const [releateType, setReleateType] = useState(null)
  const [leaveStrict, setLeaveStrict] = useState(0)
  const [openDelete, setOpenDelete] = useState(false)
  const [openRemove, setOpenRemove] = useState(false)
  const [openWarning, setOpenWarning] = useState(false)
  const [openConfirm, setOpenConfirm] = useState(false)
  const [pendingBody, setPendingBody] = useState(null)
  const [conditions, setConditions] = useState([])
  const [initialSnapshot, setInitialSnapshot] = useState(null)
  // const [selectedEmpTypes, setSelectedEmpTypes] = useState({})
  const width = window.innerWidth
  const isDesktop = width > 1024
  const { isToggleMenu } = useToggleMenuStore()
  const [strictType, setStrictType] = useState(getStrictOption('advance'))
  const [isStrictDropdownOpen, setIsStrictDropdownOpen] = useState(false)
  const strictDropdownRef = useRef(null)

  const [form, setForm] = useState({
    incHoliday: false,
    singleUse: false,
    birthdayCondition: false,
    prorated: false,
    probationId: false
  })
  const handleChange = (apiKey, checked) => {
    setForm((prev) => ({
      ...prev,
      [apiKey]: checked
    }))
  }
  const pendingStrictValue = useRef(null)

  useEffect(() => {
    if (!pendingStrictValue.current) return
    const { laterDay, advanceDay } = pendingStrictValue.current

    if (strictType?.value === 'later' && laterDay) {
      setValue('later_day', laterDay)
      setValue('advance_day', '')
    } else if (strictType?.value === 'advance' && advanceDay) {
      setValue('advance_day', advanceDay)
      setValue('later_day', '')
    }

    pendingStrictValue.current = null
  }, [strictType])

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        strictDropdownRef.current &&
        !strictDropdownRef.current.contains(event.target)
      ) {
        setIsStrictDropdownOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  useEffect(() => {
    if (idParams && !leaveTypeId) {
      setLeaveTypeId(Number(idParams))
    }
  }, [idParams])

  useEffect(() => {
    if (leaveTypeId) {
      getDetailLeave({ leaveTypeId })
    }
  }, [leaveTypeId])
  // helper สำหรับหา option แบบปลอดภัย
  const findOption = (options, value) => {
    if (!options?.length || value == null) return null
    return options.find((o) => String(o.value) === String(value)) || null
  }

  // ถ้า empType.typeId เป็น null แต่ typeName เป็น "All" ให้ใช้ EMP_TYPE.ALL (0)
  const resolveEmpTypeId = (empType) => {
    if (empType?.typeId != null) return empType.typeId
    if (empType?.typeName === 'All') return EMP_TYPE.ALL
    return null
  }

  useEffect(() => {
    if (!details || Array.isArray(details)) return // ข้ามถ้ายังเป็น initial state ([])
    if (!dataOptionMinimum?.length) return
    if (!dataOptionDuration?.length) return
    if (!empsTypes.length) return
    if (!dataSexs.length) return

    setValue(
      'leave_duration',
      findOption(dataOptionMinimum, details.minDuration)
    )
    setValue('duration_step', findOption(dataOptionDuration, details.step))
    setValue('sex', findOption(dataSexs, details.leaveEmpSex))
    setValue(
      'empType',
      findOption(empsTypes, resolveEmpTypeId(details.empType))
    )
    if (details.inheritUsedQuotaLeaveTypeId) {
      setValue(
        'relateType',
        findOption(leaveType, details.inheritUsedQuotaLeaveTypeId)
      )
    }
  }, [
    details,
    dataOptionMinimum,
    dataOptionDuration,
    empsTypes,
    dataSexs,
    leaveType,
    setValue
  ])
  const leaveStrictValid =
    leaveStrict !== 1 ||
    (leaveStrict === 1 &&
      strictType != null &&
      (Number(laterDay) > 0 || Number(advanceDay) > 0))

  const attachmentValid = !attachment || Number(attachmentValue) > 0

  const releateTypeValid = !releateType || !!relateTypeValue?.value

  const requiredFieldsFilled =
    watch('name') &&
    watch('titleTh') &&
    watch('titleEn') &&
    watch('totalDay') &&
    watch('leave_duration') &&
    watch('duration_step') &&
    watch('sex') &&
    watch('empType') &&
    effectiveStartDate &&
    leaveStrictValid &&
    attachmentValid &&
    releateTypeValid

  const getDetailLeave = async (body) => {
    setIsLoading(true)
    const res = await getDetailLeveTypeV2API(body)
    setIsLoading(false)
    if (!res || !res.status || !res.result) return
    const r = res.result
    setDetails(r)
    setSelectedUser(r)
    setLeaveStrict(r.leaveStrict ?? 0)
    const snapshot = {
      form: {
        incHoliday: !!r.incHoliday,
        singleUse: !!r.singleUse,
        birthdayCondition: !!r.birthdayCondition,
        prorated: !!r.prorated,
        probationId: !!r.probationId
      },
      leaveStrict: r.leaveStrict ?? 0,
      conditions: r.condition ?? [],
      selectedEmpTypes: {},
      effectiveStartDate: r.effectiveStart
        ? fnDateEn(r.effectiveStart).format('YYYY-MM-DD')
        : null,
      effectiveEndDate: r.effectiveEnd
        ? fnDateEn(r.effectiveEnd).format('YYYY-MM-DD')
        : null
    }

    setInitialSnapshot(snapshot)
    // -----------------------------
    // ✅ 1. set react-hook-form fields
    // -----------------------------
    reset({
      name: r.leaveType ?? '',
      titleTh: r.leaveTypeTh ?? '',
      titleEn: r.leaveTypeEn ?? '',
      desTh: r.description ?? '',
      desEn: r.descriptionEn ?? '',
      totalDay: r.leaveTypeTotal === 0 ? null : (r.leaveTypeTotal ?? null),
      max_carry: r.maxCarry === 0 ? null : (r.maxCarry ?? null),
      minimum_work_year:
        r.workYear == null || r.workYear === 0 ? '' : String(r.workYear),
      later_day: r.later === 0 ? null : (r.later ?? null),
      advance_day: r.advance === 0 ? null : (r.advance ?? null),
      attachment: r.attachment === 0 ? null : (r.attachment ?? null),
      isActive: r.leaveTypeStatus ?? true,
      leave_duration: null,
      duration_step: null,
      sex: null,
      empType: null,
      relateType: null
    })
    setForm({
      incHoliday: !!r.incHoliday,
      singleUse: !!r.singleUse,
      birthdayCondition: !!r.birthdayCondition,
      prorated: !!r.prorated,
      probationId: !!r.empProbation?.probationId
    })
    if (r.leaveStrict === 1) {
      if (r.later > 0) {
        pendingStrictValue.current = { laterDay: r.later, advanceDay: null }
        setStrictType(getStrictOption('later'))
      } else {
        // advance — strictType อาจไม่เปลี่ยน ต้อง setValue ตรงๆ ด้วย
        pendingStrictValue.current = { laterDay: null, advanceDay: r.advance }
        if (strictType?.value === 'advance') {
          // useEffect จะไม่ fire เพราะ state เดิม → set ตรงๆ เลย
          setValue('advance_day', r.advance)
          setValue('later_day', '')
          pendingStrictValue.current = null
        } else {
          setStrictType(getStrictOption('advance'))
        }
      }
    } else {
      setStrictType(getStrictOption('advance'))
    }
    setAttachment(!!r.attachment)
    setReleateType(!!r.inheritUsedQuotaLeaveTypeId)
    setEffectiveStartDate(r.effectiveStart ? fnDateEn(r.effectiveStart) : null)
    setEffectiveEndDate(r.effectiveEnd ? fnDateEn(r.effectiveEnd) : null)
    setConditions(r.condition ?? [])
  }

  const handleCancel = async () => {
    if (hasId) {
      await getDetailLeave({ leaveTypeId })
    } else {
      reset({
        isActive: true,
        name: '',
        titleTh: '',
        titleEn: '',
        desTh: '',
        desEn: '',
        totalDay: '',
        max_carry: '',
        minimum_work_year: '',
        later_day: '',
        advance_day: '',
        attachment: '',
        leave_duration: null,
        duration_step: null,
        sex: null,
        empType: null
      })
      // reset state อื่นๆ ด้วย
      setEffectiveStartDate(null)
      setEffectiveEndDate(null)
      setConditions([])
      setLeaveStrict(0)
      setStrictType(getStrictOption('advance'))
      setAttachment(null)
      setForm({
        incHoliday: false,
        singleUse: false,
        birthdayCondition: false,
        prorated: false,
        probationId: false
      })
    }

    setIsRead(true)
  }

  const handleDel = async (id) => {
    const payload = {
      leaveTypeId: +id
    }
    const resp = await delLeveTypeV2API(payload)
    if (resp?.msg === 'CANNOT_DELETE_LEAVE_TYPE_IN_USE') {
      setOpenWarning(true)
      return
    }
    if (!resp) return
    if (!resp.success) {
      Error_false({ msg: t(resp.msg), ...resp })
      return
    }
    AlertSuccess('Remove successfully.')
    goBack()
  }
  const handleRemove = async (id) => {
    const payload = {
      orgIds: roleId ? [roleId] : [],
      leaveTypeId: +id
    }
    const resp = await delAssignLeveTypeV2API(payload)
    if (!resp) return
    if (!resp.status) {
      Error_false({ msg: t(resp.msg), ...resp })
      return
    }
    AlertSuccess('Remove successfully.')
    goBack()
  }

  const goBack = () => {
    if (idPage === 'assign') {
      navigate(PAGE_SETTING_LEAVE_ASSIGN, { replace: true })
    } else {
      navigate(PAGE_SETTING_LEAVE_MAS, { replace: true })
    }
  }
  const leaveTypes = [
    {
      key: 'includeHoliday',
      apiKey: 'incHoliday',
      label: t('hrms_setting_leave_form_in_holiday'),
      description: t('hrms_setting_leave_form_in_holiday_detail')
    },
    {
      key: 'singleUse',
      apiKey: 'singleUse',
      label: t('hrms_setting_leave_form_single_use'),
      description: t('hrms_setting_leave_form_single_use_detail')
    },
    {
      key: 'birthday',
      apiKey: 'birthdayCondition',
      label: t('hrms_setting_leave_form_birthday'),
      description: t('hrms_setting_leave_form_birthday_detail')
    },
    {
      key: 'proRate',
      apiKey: 'prorated',
      label: t('hrms_setting_leave_form_pro_rate'),
      description: t('hrms_setting_leave_form_pro_rate_detail')
    },
    {
      key: 'probation',
      apiKey: 'probationId',
      label: t('hrms_setting_leave_form_probation'),
      description: t('hrms_setting_leave_form_probation_detail')
    }
  ]
  const isOtherChanged =
    hasId &&
    initialSnapshot &&
    (JSON.stringify(form) !== JSON.stringify(initialSnapshot.form) ||
      leaveStrict !== initialSnapshot.leaveStrict ||
      JSON.stringify(conditions) !==
        JSON.stringify(initialSnapshot.conditions) ||
      effectiveStartDate?.format('YYYY-MM-DD') !==
        initialSnapshot.effectiveStartDate ||
      effectiveEndDate?.format('YYYY-MM-DD') !==
        initialSnapshot.effectiveEndDate)
  const isButtonDisabled = hasId
    ? !(isDirty || isOtherChanged) || !requiredFieldsFilled
    : !requiredFieldsFilled
  const isViewMode = hasId && isRead
  const addCondition = () => {
    setConditions([
      ...conditions,
      {
        minWork: 0,
        total: 0
      }
    ])
  }

  const removeCondition = (index) => {
    setConditions(conditions.filter((_, i) => i !== index))
  }

  const handleChangeAddCondition = (index, field, value) => {
    setConditions((prev) =>
      prev.map((item, i) => (i === index ? { ...item, [field]: value } : item))
    )
  }

  const buildBody = (data) => {
    return {
      ...form,
      leaveType: data.name ?? '',
      leaveTypeTh: data.titleTh ?? '',
      leaveTypeEn: data.titleEn ?? '',
      leaveTypeTotal: Number(data.totalDay) || null,
      typeId: data.empType?.value === 0 ? null : data.empType?.value,
      sex: data.sex?.value ?? null,
      workYear: Number(data.minimum_work_year) || null,
      attachment: Number(data.attachment) || null,
      inheritUsedQuotaLeaveTypeId:
        releateType && data.relateType ? data.relateType.value : null,
      minDuration: Number(data.leave_duration?.value) || null,
      later: leaveStrict === 1 ? Number(data.later_day) || 0 : 0,
      advance: leaveStrict === 1 ? Number(data.advance_day) || 0 : 0,
      description: data.desTh ?? '',
      descriptionEn: data?.desEn ?? '',
      leaveStrict,
      step: data.duration_step?.value ?? null,
      maxCarry: data.max_carry ?? null,
      leaveTypeStatus: data.isActive ? 1 : 0,
      effectiveStart: effectiveStartDate
        ? effectiveStartDate.startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS')
        : null,

      effectiveEnd: effectiveEndDate
        ? effectiveEndDate.endOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS')
        : null,
      condition: conditions
    }
  }
  const saveLeaveType = async (body) => {
    let result

    if (hasId) {
      result = await putLeveTypeV2API({ leaveTypeId }, body)
    } else {
      result = await postLeveTypeV2API(body)
    }

    if (!result) return

    if (result.success) {
      AlertSuccess()
      if (!hasId && result?.result?.leaveTypeId) {
        const newId = result.result.leaveTypeId
        setLeaveTypeId(newId)

        navigate(`/setting/noti/add?id=${newId}`, {
          replace: true
        })
      }
      navigate(PAGE_SETTING_LEAVE_MAS)
      setIsRead(true)
    } else {
      Error_false({ msg: t(result.msg)})
    }
  }
  const onSubmitLeave = (data) => {
    const body = buildBody(data)
    setPendingBody(body)
    setOpenConfirm(true)
  }

  return (
    <>
      <NavTitle>
        <BtnBack2
          onClick={goBack}
          text={
            !id
              ? `${t('hrms_setting_leave_add_leave')}`
              : isRead
                ? `${t('hrms_setting_leave_view_leave')}`
                : `${t('hrms_setting_leave_edit_leave')}`
          }
        />
      </NavTitle>
      <Form onSubmit={handleSubmit(onSubmitLeave)}>
        <Row className="pb-5">
          <Col xl={12} className="mb-4">
            <CardCustom>
              <Row className="p-3">
                <div className="d-flex justify-content-between">
                  <TitleCustom icon={<IconLeave />}>
                    {t('hrms_setting_leave_form_detail')}
                  </TitleCustom>
                  {idPage !== 'org' && idPage !== 'assign' && isViewMode && (
                    <Button
                      size="sm"
                      type="button"
                      className="bt-primary px-3"
                      onClick={() => setIsRead(false)}
                    >
                      <FaRegPenToSquare
                        style={{ width: '14px' }}
                        className="me-2"
                      />
                      {t('hrms_setting_leave_edit_btn')}
                    </Button>
                  )}
                </div>

                <Col xl={12} md={12} className="mb-2"></Col>
                {id ? (
                  <div className="py-2">
                    <div className="pb-2">
                      <span style={{ fontSize: '14px' }}>
                        {t('hrms_setting_leave_from_assign_to')}
                      </span>
                    </div>
                    <div className="d-flex flex-row flex-wrap gap-2 font-small-2">
                      {details?.orgAssign?.length > 0 ? (
                        <TagOrgList
                          orgAssign={details.orgAssign}
                          direction="row"
                          isMore={false}
                        />
                      ) : (
                        '-'
                      )}
                    </div>
                  </div>
                ) : null}
                <Col xl={4} md={4} className="my-2">
                  <LabelCustom>
                    {' '}
                    {t('hrms_setting_leave_form_name')}
                  </LabelCustom>
                  <span className="text-danger mx-1">*</span>
                  <Controller
                    name={'name'}
                    control={control}
                    render={({ field: { onChange, value = '' } }) => (
                      <div style={{ position: 'relative' }}>
                        <Form.Control
                          disabled={isViewMode}
                          label=""
                          value={value}
                          maxLength={100}
                          onChange={onChange}
                          placeholder={t(
                            'hrms_setting_leave_form_place_holder_name'
                          )}
                        />
                        {!isViewMode && (
                          <div
                            style={{
                              position: 'absolute',
                              bottom: '-20px',
                              right: '0',
                              fontSize: '12px',
                              color: 'var(--color-on-base-content-subtle)',
                              fontWeight: 400
                            }}
                          >
                            {value.length}/100
                          </div>
                        )}
                      </div>
                    )}
                  />
                </Col>
                <Col xl={4} md={4} className="my-2">
                  <LabelCustom>
                    {' '}
                    {t('hrms_setting_leave_form_title_en')}
                  </LabelCustom>
                  <span className="text-danger mx-1">*</span>
                  <Controller
                    name={'titleEn'}
                    control={control}
                    render={({ field: { onChange, value = '' } }) => (
                      <Form.Control
                        disabled={isViewMode}
                        label=""
                        value={value}
                        onChange={onChange}
                        placeholder={t(
                          'hrms_setting_leave_form_place_holder_title_en'
                        )}
                      />
                    )}
                  />
                </Col>

                <Col xl={4} md={4} className="my-2">
                  <LabelCustom>
                    {' '}
                    {t('hrms_setting_leave_form_title_th')}
                  </LabelCustom>
                  <span className="text-danger mx-1">*</span>
                  <Controller
                    name={'titleTh'}
                    control={control}
                    render={({ field: { onChange, value = '' } }) => (
                      <Form.Control
                        disabled={isViewMode}
                        label=""
                        value={value}
                        onChange={onChange}
                        placeholder={t(
                          'hrms_setting_leave_form_place_holder_title_th'
                        )}
                      />
                    )}
                  />
                </Col>
                <Col xl={12} md={12} className="my-2">
                  <LabelCustom>
                    {' '}
                    {t('hrms_setting_leave_form_description_en')}
                  </LabelCustom>
                  <Controller
                    name={'desEn'}
                    control={control}
                    render={({ field: { onChange, value = '' } }) => (
                      <Form.Control
                        disabled={isViewMode}
                        label=""
                        value={value}
                        onChange={onChange}
                        placeholder={t(
                          'hrms_setting_leave_form_description_place_holder_en'
                        )}
                      />
                    )}
                  />
                </Col>
                <Col xl={12} md={12} className="my-2">
                  <LabelCustom>
                    {' '}
                    {t('hrms_setting_leave_form_description_th')}
                  </LabelCustom>
                  <Controller
                    name={'desTh'}
                    control={control}
                    render={({ field: { onChange, value = '' } }) => (
                      <Form.Control
                        disabled={isViewMode}
                        label=""
                        value={value}
                        onChange={onChange}
                        placeholder={t(
                          'hrms_setting_leave_form_description_place_holder_th'
                        )}
                      />
                    )}
                  />
                </Col>
                <Col xl={4} md={4} className="my-2">
                  <LabelCustom>
                    {' '}
                    {t('hrms_setting_leave_form_total_day')}
                  </LabelCustom>
                  <span className="text-danger mx-1">*</span>
                  <Controller
                    name={'totalDay'}
                    control={control}
                    render={({ field: { onChange, value = '' } }) => (
                      <Form.Control
                        inputMode="numeric"
                        maxLength={2}
                        disabled={isViewMode}
                        label=""
                        value={value}
                        onChange={(e) => {
                          const onlyNumber = e.target.value.replace(/\D/g, '') // เอาเฉพาะตัวเลข
                          const limitTwoDigit = onlyNumber.slice(0, 2) // จำกัด 2 หลัก
                          onChange(limitTwoDigit)
                        }}
                        placeholder={t(
                          'hrms_setting_leave_form_place_holder_total_day'
                        )}
                      />
                    )}
                  />
                </Col>
                <Col xl={4} md={4} className="my-2">
                  <LabelCustom>
                    {' '}
                    {t('hrms_setting_leave_form_max_carry_day')}
                  </LabelCustom>
                  <Controller
                    name={'max_carry'}
                    control={control}
                    render={({ field: { onChange, value = '' } }) => (
                      <Form.Control
                        inputMode="numeric"
                        maxLength={2}
                        disabled={isViewMode}
                        label=""
                        value={value}
                        onChange={(e) => {
                          const onlyNumber = e.target.value.replace(/\D/g, '') // เอาเฉพาะตัวเลข
                          const limitTwoDigit = onlyNumber.slice(0, 2) // จำกัด 2 หลัก
                          onChange(limitTwoDigit)
                        }}
                        placeholder={t(
                          'hrms_setting_leave_form_place_holder_max_carry_day'
                        )}
                      />
                    )}
                  />
                </Col>
                <Col xl={4} md={4}></Col>
                <Col xl={4} md={4} className="my-2">
                  <LabelCustom>
                    {' '}
                    {t('hrms_setting_leave_form_min_leave')}
                  </LabelCustom>
                  <span className="text-danger mx-1">*</span>
                  <Controller
                    name={'leave_duration'}
                    control={control}
                    render={({ field: { onChange, value = '' } }) => (
                      <Autocomplete
                        isClearable={false}
                        disabled={isViewMode}
                        options={dataOptionMinimum}
                        value={value}
                        onChange={onChange}
                        placeholder={t(
                          'hrms_setting_leave_form_place_holder_min_leave'
                        )}
                      />
                    )}
                  />
                </Col>
                <Col xl={4} md={4} className="my-2">
                  <LabelCustom>
                    {' '}
                    {t('hrms_setting_leave_form_duration_step')}
                  </LabelCustom>
                  <span className="text-danger mx-1">*</span>
                  <Controller
                    name={'duration_step'}
                    control={control}
                    render={({ field: { onChange, value = '' } }) => (
                      <Autocomplete
                        isClearable={false}
                        disabled={isViewMode}
                        options={dataOptionDuration}
                        value={value}
                        onChange={onChange}
                        placeholder={t(
                          'hrms_setting_leave_form_place_holder_duration_step'
                        )}
                      />
                    )}
                  />
                </Col>
                <Col xl={4} md={4}></Col>
                <Col xl={4} md={4} className="my-2">
                  <LabelCustom>
                    {' '}
                    {t('hrms_setting_leave_form_employee_type')}
                  </LabelCustom>
                  <span className="text-danger mx-1">*</span>
                  <Controller
                    name={'empType'}
                    control={control}
                    render={({ field: { onChange, value = '' } }) => (
                      <Autocomplete
                        isClearable={false}
                        disabled={isViewMode}
                        options={empsTypes}
                        value={value}
                        onChange={onChange}
                        placeholder={t(
                          'hrms_setting_leave_form_place_holder_description'
                        )}
                      />
                    )}
                  />
                </Col>
                <Col xl={4} md={4} className="my-2">
                  <LabelCustom> {t('hrms_setting_leave_form_sex')}</LabelCustom>
                  <span className="text-danger mx-1">*</span>
                  <Controller
                    name={'sex'}
                    control={control}
                    render={({ field: { onChange, value = '' } }) => (
                      <Autocomplete
                        isClearable={false}
                        disabled={isViewMode}
                        options={dataSexs}
                        value={value}
                        onChange={onChange}
                        placeholder={t(
                          'hrms_setting_leave_form_place_holder_sex'
                        )}
                      />
                    )}
                  />
                </Col>
                <Col xl={4} md={4}></Col>
                <Col xl={12} md={12} className="my-3">
                  <LabelHeaderCustom className="mb-2">
                    {t('hrms_setting_leave_form_condition_topic')}
                  </LabelHeaderCustom>
                  <Card
                    style={{
                      borderRadius: '8px',
                      border: ' 1px solid var(--color-on-base-border-default)'
                    }}
                  >
                    <Row className="p-3">
                      {leaveTypes.map((item) => (
                        <>
                          <Col
                            xl={4}
                            md={6}
                            xs={12}
                            key={item.apiKey}
                            className="my-2"
                          >
                            <div className="d-flex flex-column">
                              <Checkbox
                                disabled={isViewMode}
                                className="generic-table-wrapper"
                                checked={form[item.apiKey]}
                                onChange={(e) =>
                                  handleChange(item.apiKey, e.target.checked)
                                }
                              >
                                <div className="check-content">
                                  <div
                                    style={{
                                      fontSize: '16px',
                                      fontWeight: 500,
                                      color:
                                        ' var(--color-on-base-content-high)'
                                    }}
                                  >
                                    {t(item.label)}
                                  </div>
                                </div>
                              </Checkbox>
                              <div
                                className="font-small-2"
                                style={{
                                  color: 'var(--color-on-base-border-default)'
                                }}
                              >
                                {t(item.description)}
                              </div>
                            </div>
                          </Col>
                        </>
                      ))}
                      <Col xl={4} md={6} xs={12} className="">
                        <LabelCustom>
                          {' '}
                          {t('hrms_setting_leave_form_min_year')}
                        </LabelCustom>
                        <Controller
                          name={'minimum_work_year'}
                          control={control}
                          render={({ field: { onChange, value = '' } }) => (
                            <Form.Control
                              inputMode="numeric"
                              maxLength={2}
                              disabled={isViewMode}
                              label=""
                              value={value}
                              onChange={(e) => {
                                const onlyNumber = e.target.value.replace(
                                  /\D/g,
                                  ''
                                ) // เอาเฉพาะตัวเลข
                                const limitTwoDigit = onlyNumber.slice(0, 2) // จำกัด 2 หลัก
                                onChange(limitTwoDigit)
                              }}
                              placeholder={t(
                                'hrms_setting_leave_form_place_holder_min_year'
                              )}
                            />
                          )}
                        />
                      </Col>
                    </Row>
                  </Card>
                </Col>

                <Col xl={12} md={12} className="my-3">
                  <div className="d-flex align-items-center justify-content-between gap-3">
                    <LabelHeaderCustom>
                      {' '}
                      {t('hrms_setting_leave_form_additional_condition')}
                    </LabelHeaderCustom>
                    {!isViewMode && (
                      <Button
                        className="px-3 bt-primary"
                        onClick={addCondition}
                      >
                        <HiOutlinePlus />{' '}
                        {t('hrms_setting_leave_form_add_bt_condition')}
                      </Button>
                    )}
                  </div>
                  <Card
                    style={{
                      borderRadius: '8px',
                      border: ' 1px solid var(--color-on-base-border-default)',
                      height: conditions.length > 0 ? '' : '54px',
                      margin: '9px 0px',
                      padding: '15px'
                    }}
                  >
                    {conditions.length > 0 ? (
                      conditions.map((item, index) => {
                        return (
                          <>
                            <div className="d-flex flex-row gap-3">
                              <div
                                key={index}
                                className="d-flex align-items-center gap-3 rounded my-1"
                              >
                                <span
                                  style={{
                                    fontSize: '16px',
                                    fontWeight: 400
                                  }}
                                >
                                  {t(
                                    'hrms_setting_leave_form_condition_min_work'
                                  )}
                                </span>

                                {/* minWork */}
                                <Form.Control
                                  type="text"
                                  inputMode="numeric"
                                  maxLength={2}
                                  disabled={isViewMode}
                                  value={item.minWork ?? ''}
                                  // className="form-control"
                                  style={{ width: '44px', textAlign: 'center' }}
                                  onChange={(e) => {
                                    let val = e.target.value.replace(/\D/g, '')
                                    // if (Number(val) > 99) val = '99'
                                    handleChangeAddCondition(
                                      index,
                                      'minWork',
                                      val
                                    )
                                  }}
                                />

                                <span
                                  style={{
                                    fontSize: '16px',
                                    fontWeight: 400
                                  }}
                                >
                                  {t(
                                    'hrms_setting_leave_form_condition_total_day'
                                  )}
                                </span>

                                {/* total */}
                                <Form.Control
                                  type="text"
                                  inputMode="numeric"
                                  maxLength={2}
                                  disabled={isViewMode}
                                  value={item.total ?? ''}
                                  style={{ width: '44px', textAlign: 'center' }}
                                  onChange={(e) => {
                                    let val = e.target.value.replace(/\D/g, '')
                                    handleChangeAddCondition(
                                      index,
                                      'total',
                                      val
                                    )
                                  }}
                                />

                                {!isViewMode && (
                                  <div
                                    onClick={() => removeCondition(index)}
                                    style={{
                                      width: 24,
                                      height: 24,
                                      borderRadius: 6,
                                      border:
                                        '1px solid var(--color-on-base-border-default)',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      cursor: 'pointer'
                                    }}
                                  >
                                    <BsX size={20} />
                                  </div>
                                )}
                              </div>
                              <div className="d-flex align-items-center justify-content-center">
                                {item.minWork >= 1 && item.total >= 1 && (
                                  <span
                                    style={{
                                      color:
                                        'var(--color-on-base-content-subtle)'
                                    }}
                                  >
                                    {formatString(
                                      t(
                                        'hrms_setting_leave_form_condition_summary'
                                      ),
                                      item.minWork ?? 0,
                                      item.total ?? 0,
                                      Number(totalDay || 0) +
                                        Number(item.total ?? 0)
                                    )}
                                  </span>
                                )}
                              </div>
                            </div>
                          </>
                        )
                      })
                    ) : (
                      <div
                        className="font-small-2 text-center my-auto"
                        style={{ color: '#7f7f7f' }}
                      >
                        {t('hrms_setting_leave_form_no_data')}
                      </div>
                    )}
                  </Card>
                </Col>
                <Col xl={4} md={4} className="mb-2">
                  <Checkbox
                    disabled={isViewMode}
                    name="leaveStrict"
                    className="generic-table-wrapper mb-2"
                    checked={leaveStrict === 1}
                    onChange={(e) => {
                      const checked = e.target.checked
                      setLeaveStrict(checked ? 1 : 0)
                      if (!checked) {
                        setValue('later_day', '')
                        setValue('advance_day', '')
                        setStrictType(getStrictOption('advance'))
                        setIsStrictDropdownOpen(false)
                      } else {
                        setStrictType(getStrictOption('advance'))
                        setValue('later_day', '')
                        setValue('advance_day', '')
                      }
                    }}
                  >
                    <div className="check-content">
                      <div
                        style={{
                          fontSize: '16px',
                          fontWeight: 500,
                          color: 'var(--color-on-base-content-high)'
                        }}
                      >
                        {t('hrms_setting_leave_form_leave_strict')}
                      </div>
                    </div>
                  </Checkbox>

                  <div
                    style={{
                      fontSize: '16px',
                      fontWeight: 500,
                      color: 'var(--color-on-base-content-high)'
                    }}
                  >
                    <LabelCustom>
                      {t('hrms_setting_leave_form_title_leave_strict')}
                    </LabelCustom>
                    {leaveStrict === 1 && (
                      <span
                        className="text-danger mx-2"
                        style={{ fontSize: '12px' }}
                      >
                        *
                      </span>
                    )}
                  </div>

                  <div
                    className="input-group"
                    style={{
                      width: '100%',
                      flexWrap: 'nowrap',
                      overflow: 'visible'
                    }}
                  >
                    <div
                      className="input-group-prepend"
                      ref={strictDropdownRef}
                      style={{
                        flex: '0 0 auto',
                        minWidth: '100px',
                        maxWidth: '40%',
                        position: 'relative'
                      }}
                    >
                      <button
                        type="button"
                        disabled={isViewMode || leaveStrict !== 1}
                        className="btn dropdown-toggle"
                        aria-haspopup="true"
                        aria-expanded={isStrictDropdownOpen}
                        onClick={() => {
                          if (isViewMode || leaveStrict !== 1) return
                          setIsStrictDropdownOpen((prev) => !prev)
                        }}
                        style={{
                          width: '100%',
                          height: '38px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          gap: '8px',
                          border: 'none',
                          borderRight:
                            '1px solid var(--color-on-base-border-default)',
                          borderRadius: '8px 0 0 8px',
                          backgroundColor:
                            isViewMode || leaveStrict !== 1
                              ? 'var(--color-base-background-subtle)'
                              : 'var(--color-base-background-default)',
                          color:
                            isViewMode || leaveStrict !== 1
                              ? 'var(--color-on-base-content-disable)'
                              : strictType
                                ? 'var(--color-on-base-content-high)'
                                : 'var(--color-on-base-content-subtle)',
                          // borderColor:
                          //   isViewMode || leaveStrict !== 1
                          //     ? 'var(--color-on-base-border-disable)'
                          //     : 'var(--color-on-base-border-default)',
                          cursor:
                            isViewMode || leaveStrict !== 1
                              ? 'not-allowed'
                              : 'pointer',
                          fontSize: '14px',
                          opacity: 1
                        }}
                      >
                        {strictType?.value === 'later'
                          ? t('hrms_setting_leave_form_title_later')
                          : strictType?.value === 'advance'
                            ? t('hrms_setting_leave_form_title_advance')
                            : t('hrms_setting_leave_form_place_holder_strict')}
                      </button>
                      <div
                        className={`dropdown-menu ${isStrictDropdownOpen ? 'show' : ''}`}
                        style={{
                          zIndex: 1100,
                          minWidth: '100%',
                          marginTop: '2px'
                        }}
                      >
                        <button
                          type="button"
                          className={`dropdown-item ${strictType?.value === 'later' ? 'active' : ''}`}
                          onClick={() => {
                            if (strictType?.value !== 'later') {
                              setStrictType({
                                value: 'later',
                                label: t('hrms_setting_leave_form_title_later')
                              })
                              setValue('later_day', '')
                              setValue('advance_day', '')
                            }
                            setIsStrictDropdownOpen(false)
                          }}
                        >
                          {t('hrms_setting_leave_form_title_later')}
                        </button>
                        <button
                          type="button"
                          className={`dropdown-item ${strictType?.value === 'advance' ? 'active' : ''}`}
                          onClick={() => {
                            if (strictType?.value !== 'advance') {
                              setStrictType({
                                value: 'advance',
                                label: t(
                                  'hrms_setting_leave_form_title_advance'
                                )
                              })
                              setValue('later_day', '')
                              setValue('advance_day', '')
                            }
                            setIsStrictDropdownOpen(false)
                          }}
                        >
                          {t('hrms_setting_leave_form_title_advance')}
                        </button>
                      </div>
                    </div>

                    <div style={{ flex: '1 1 0', minWidth: 0 }}>
                      {strictType?.value === 'later' ? (
                        <Controller
                          name="later_day"
                          control={control}
                          render={({ field: { onChange, value = '' } }) => (
                            <Form.Control
                              disabled={isViewMode || leaveStrict !== 1}
                              inputMode="numeric"
                              maxLength={2}
                              value={value}
                              style={{
                                borderRadius: '0 8px 8px 0',
                                height: '38px',
                                width: '100%',
                                maxWidth: '100%'
                              }}
                              onChange={(e) => {
                                const onlyNumber = e.target.value.replace(
                                  /\D/g,
                                  ''
                                )
                                const limitTwoDigit = onlyNumber.slice(0, 2)
                                onChange(limitTwoDigit)
                                setValue('advance_day', '')
                              }}
                              placeholder={t(
                                'hrms_setting_leave_form_place_holder_strict'
                              )}
                            />
                          )}
                        />
                      ) : strictType?.value === 'advance' ? (
                        <Controller
                          name="advance_day"
                          control={control}
                          render={({ field: { onChange, value = '' } }) => (
                            <Form.Control
                              disabled={isViewMode || leaveStrict !== 1}
                              inputMode="numeric"
                              maxLength={2}
                              value={value}
                              style={{
                                borderRadius: '0 8px 8px 0',
                                height: '38px',
                                width: '100%'
                              }}
                              onChange={(e) => {
                                const onlyNumber = e.target.value.replace(
                                  /\D/g,
                                  ''
                                )
                                const limitTwoDigit = onlyNumber.slice(0, 2)
                                onChange(limitTwoDigit)
                                setValue('later_day', '')
                              }}
                              placeholder={t(
                                'hrms_setting_leave_form_place_holder_advance'
                              )}
                            />
                          )}
                        />
                      ) : (
                        <Form.Control
                          disabled
                          placeholder="-"
                          style={{
                            borderRadius: '0 8px 8px 0',
                            boxShadow: 'none',
                            height: '38px',
                            width: '100%'
                          }}
                        />
                      )}
                    </div>
                  </div>
                </Col>
                <Col xl={4} md={4} className="mb-2">
                  <Row>
                    <Col xl={12} md={12} className="mb-2">
                      <Checkbox
                        disabled={isViewMode}
                        className="generic-table-wrapper mb-2"
                        checked={attachment}
                        onChange={(e) => {
                          setAttachment(e.target.checked)
                          if (!e.target.checked) {
                            setValue('attachment', '')
                          }
                        }}
                      >
                        <div className="check-content">
                          <div
                            style={{
                              fontSize: '16px',
                              fontWeight: 500,
                              color: ' var(--color-on-base-content-high)'
                            }}
                          >
                            {t('hrms_setting_leave_form_require_file')}
                          </div>
                        </div>
                      </Checkbox>
                      <div>
                        <LabelCustom>
                          {t('hrms_setting_leave_form_title_amount_leave')}
                        </LabelCustom>
                        {attachment ? (
                          <span className="text-danger mx-1">*</span>
                        ) : null}
                      </div>
                      <Controller
                        name={'attachment'}
                        control={control}
                        render={({ field: { onChange, value = '' } }) => (
                          <Form.Control
                            inputMode="numeric"
                            maxLength={2}
                            disabled={isViewMode || !attachment}
                            label=""
                            value={value}
                            onChange={(e) => {
                              const onlyNumber = e.target.value.replace(
                                /\D/g,
                                ''
                              )
                              const limitTwoDigit = onlyNumber.slice(0, 2)
                              onChange(limitTwoDigit)
                            }}
                            placeholder={t(
                              'hrms_setting_leave_form_place_holder_amount_leave'
                            )}
                          />
                        )}
                      />
                    </Col>
                  </Row>
                </Col>
                <Col xl={4} md={4} className="mb-2">
                  <Checkbox
                    disabled={isViewMode}
                    className="generic-table-wrapper mb-2"
                    checked={releateType}
                    onChange={(e) => {
                      setReleateType(e.target.checked)
                      if (!e.target.checked) {
                        setValue('relateType', null)
                      }
                    }}
                  >
                    <div className="check-content">
                      <div>
                        <span style={{ fontSize: '16px' }}>
                          {t(
                            'hrms_setting_leave_employee_form_inherit_used_quota'
                          )}
                        </span>
                      </div>
                    </div>
                  </Checkbox>
                  <div>
                    <LabelCustom>
                      {t('hrms_setting_leave_employee_form_relate_type')}
                    </LabelCustom>
                    {releateType ? (
                      <span className="text-danger mx-1">*</span>
                    ) : null}
                  </div>
                  <Controller
                    name={'relateType'}
                    control={control}
                    render={({ field: { onChange, value = '' } }) => (
                      <Autocomplete
                        isClearable={true}
                        disabled={isViewMode || !releateType}
                        options={leaveType}
                        value={value}
                        onChange={onChange}
                        placeholder={t(
                          'hrms_setting_leave_employee_form_relate_type_placeholder'
                        )}
                      />
                    )}
                  />
                </Col>
                <Col xl={4} md={4} className="mb-2">
                  <LabelCustom>
                    {' '}
                    {t('hrms_setting_leave_form_effective_start')}
                  </LabelCustom>
                  <span className="text-danger mx-1">*</span>
                  <DatePickerGuide
                    disabled={isViewMode}
                    value={effectiveStartDate}
                    allowClear={true}
                    placeholder={t(
                      'hrms_setting_leave_form_place_holder_effective_start'
                    )}
                    onChange={(date) => {
                      setEffectiveStartDate(date)
                    }}
                  />
                </Col>
                <Col xl={4} md={4} className="mb-2">
                  <LabelCustom>
                    {' '}
                    {t('hrms_setting_leave_form_effective_end')}
                  </LabelCustom>
                  <DatePickerGuide
                    disabled={isViewMode}
                    value={effectiveEndDate}
                    allowClear={true}
                    placeholder={t(
                      'hrms_setting_leave_form_place_holder_effective_end'
                    )}
                    disabledDate={(current) => {
                      if (!effectiveStartDate) return false
                      return (
                        current && current < effectiveStartDate.startOf('day')
                      )
                    }}
                    onChange={(date) => {
                      setEffectiveEndDate(date)
                    }}
                  />
                </Col>
                <Col xl={4} md={4} className="mb-2"></Col>
                <Col md={12} className="mb-2 mt-2">
                  <LabelCustom>
                    {' '}
                    {t('hrms_setting_leave_form_status')}
                  </LabelCustom>
                  <Controller
                    name="isActive"
                    control={control}
                    render={({ field }) => (
                      <SwitchStatus
                        value={field.value}
                        onChange={field.onChange}
                        isViewMode={isViewMode}
                        activeText={t('hrms_setting_leave_form_active')}
                        inactiveText={t('hrms_setting_leave_form_inactive')}
                      />
                    )}
                  />
                </Col>
              </Row>
            </CardCustom>
          </Col>
          <div
            style={{
              position: 'fixed',
              bottom: 0,
              left: isDesktop ? (isToggleMenu ? 240 : 77) : 0,
              width: isDesktop
                ? `calc(100% - ${isToggleMenu ? 240 : 77}px)`
                : '100%',
              zIndex: 1000,
              background: '#fff',
              borderTop: '1px solid var(--color-base-border-default)',
              boxShadow:
                '0px 0px 1px 0px #0000001F, 0px 4px 16px -4px #00000014',
              transition: 'left 0.3s ease-in-out, width 0.3s ease-in-out'
            }}
          >
            <div
              style={{
                padding: '12px 16px',
                gap: 12
              }}
            >
              {hasId ? (
                // ====== EDIT MODE (มี id) ======
                <>
                  {!isRead ? (
                    <Row>
                      <Col>
                        <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                          {/* Delete */}
                          <Button
                            className="px-4 btn-responsive bt-del"
                            onClick={() => setOpenDelete(true)}
                          >
                            {t('hrms_notification_btn_delete')}
                          </Button>

                          {/* Cancel + Save */}
                          <div className="d-flex gap-2">
                            <Button
                              type="button"
                              className="btn-responsive bt-cancel"
                              onClick={handleCancel}
                            >
                              {t('hrms_notification_btn_cancel')}
                            </Button>

                            <Button
                              type="submit"
                              className="btn-responsive"
                              style={{
                                borderRadius: 12,
                                whiteSpace: 'nowrap',
                                borderColor: isButtonDisabled
                                  ? 'var(--color-on-base-border-disable)'
                                  : '',
                                backgroundColor: isButtonDisabled
                                  ? 'var(--comp-btn-color-background-disable)'
                                  : '',
                                color: isButtonDisabled
                                  ? 'var(--color-on-base-content-disable)'
                                  : ''
                              }}
                              disabled={isButtonDisabled}
                            >
                              {t('hrms_notification_btn_save')}
                            </Button>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  ) : (
                    <Row className="align-items-end">
                      {idPage === 'org' ? (
                        <Col>
                          <Button
                            className="px-4 btn-responsive bt-del"
                            onClick={() => setOpenRemove(true)}
                          >
                            {t('hrms_notification_btn_delete')}
                          </Button>
                        </Col>
                      ) : (
                        <Col>
                          {details?.updatedDate && details?.updatedBy && (
                            <div
                              style={{
                                fontSize: '12px',
                                fontWeight: 400,
                                color: 'var(--color-on-base-content-high)'
                              }}
                            >
                              {`Lastest updated at: ${fnDateEn(
                                details.updatedDate
                              ).format('DD/MM/YYYY')} ${details.updatedBy}`}
                            </div>
                          )}
                        </Col>
                      )}

                      <Col className="d-flex justify-content-end">
                        <Button
                          style={{ width: '164px' }}
                          className="bt-cancel"
                          type="button"
                          onClick={goBack}
                        >
                          {t('hrms_setting_location_close_bt')}
                        </Button>
                      </Col>
                    </Row>
                  )}
                </>
              ) : (
                // ====== ADD MODE (ไม่มี id) ======
                <div className="d-flex gap-2 justify-content-end">
                  <Button
                    type="button"
                    className="btn-responsive bt-cancel"
                    onClick={goBack}
                  >
                    {t('hrms_notification_btn_cancel')}
                  </Button>

                  <Button
                    type="submit"
                    className="btn-responsive"
                    style={{
                      borderRadius: 12,
                      whiteSpace: 'nowrap',
                      borderColor: isButtonDisabled
                        ? 'var(--color-on-base-border-disable)'
                        : '',
                      backgroundColor: isButtonDisabled
                        ? 'var(--comp-btn-color-background-disable)'
                        : '',
                      color: isButtonDisabled
                        ? 'var(--color-on-base-content-disable)'
                        : ''
                    }}
                    disabled={isButtonDisabled}
                  >
                    {t('hrms_notification_btn_save')}
                  </Button>
                </div>
              )}
            </div>
          </div>
        </Row>
      </Form>
      <ModalAlert
        ceantered
        open={openDelete}
        icon={<IconWarning width={74} />}
        title={t('hrms_setting_leave_modal_del_title')}
        description={t('hrms_setting_leave_modal_del_sub_title')}
        okText={t('hrms_setting_leave_del_yes_bt')}
        cancelText={t('hrms_setting_leave_del_no_bt')}
        okType="danger"
        okStyle={{
          background: 'var(--color-functional-foreground-error)',
          fontWeight: 500,
          color: 'var(--color-on-primary-content-high)'
        }}
        titleColor="var(--color-accent-content-red)"
        onOk={() => {
          idParams && handleDel(idParams) // ✅ id จริง
          setOpenDelete(false)
        }}
        onCancel={() => {
          setOpenDelete(false)
        }}
      />
      <ModalAlert
        centered
        open={openRemove}
        icon={<IconWarning width={74} />}
        title="Remove this Leave type"
        description="Do you want to remove this Leave type from the Leave type list?"
        okText="Yes"
        cancelText="No"
        okType="danger"
        okStyle={{
          background: 'var(--color-functional-foreground-error)',
          fontWeight: 500,
          color: 'var(--color-on-primary-content-high)'
        }}
        titleColor="var(--color-accent-content-red)"
        onOk={() => {
          idParams && handleRemove(idParams) // ✅ id จริง
          setOpenRemove(false)
        }}
        onCancel={() => {
          setOpenRemove(false)
        }}
      />

      <ModalAlert
        centered
        open={openConfirm}
        icon={<IconWarning width={74} />}
        title={t('hrms_setting_leave_modal_cf_title')}
        description={t('hrms_setting_leave_modal_cf_sub_title')}
        okText={t('hrms_setting_leave_cf_yes_bt')}
        cancelText={t('hrms_setting_leave_cf_no_bt')}
        okStyle={{
          background: '#2C5DFE',
          fontWeight: 500,
          color: 'var(--color-on-primary-content-high)'
        }}
        onOk={() => {
          setOpenConfirm(false)
          saveLeaveType(pendingBody)
        }}
        onCancel={() => {
          setOpenConfirm(false)
        }}
      />

      <ModalAlert
        centered
        open={openWarning}
        icon={<IconWarning width={74} />}
        title={t('hrms_setting_leave_modal_assign_title')}
        description={t('hrms_setting_leave_modal_assign_sub_title')}
        okText={t('hrms_setting_leave_assign_yes_bt')}
        okStyle={{
          background: 'var(--color-functional-foreground-error)',
          fontWeight: 500,
          color: 'var(--color-on-primary-content-high)'
        }}
        titleColor="var(--color-accent-content-red)"
        onOk={() => {
          setOpenWarning(false)
        }}
      />
    </>
  )
}
